<template>
  <div>
    <div class="inner-content">
      <h2>{{ $t('notification_management') }}</h2>
      <div class="patients-checkbox-area float-right">
        <div class="btn-patient-active mr-0">
          <a href="javascript:;" @click="$router.push('/notifications/management/new')">
            <p>
              <span class="icon-pen">{{ $t('add_new') }}</span>
            </p>
          </a>
        </div>
      </div>
      <div class="patients-list-table">
        <table>
          <tr>
            <th>{{ $t('title') }}</th>
            <th>{{ $t('status') }}</th>
            <th>{{ $t('author') }}</th>
            <th>{{ $t('date_and_time_of_transmission') }}</th>
            <th></th>
          </tr>
          <tr v-for="(item, index) in pageOfItems" :key="index" >
            <td>{{item.title}}</td>
            <!-- 
              status = 0: sent
              status = 1: save 
            -->
            <td>{{parseInt(item.status) == 0 ? $t('drafting') : $t('sent')}}</td>
            <td>{{item.dr_user_id}}</td>
            <td>{{item.sending_time}}</td>
            <td>
                <a class="display-btn" @click="clickEdit(item)">{{ $t('display') }}</a>
                <!-- show delete btn if status is draft -->
                <a v-if="parseInt(item.status) == 0" class="delete-btn" @click="clickDelete(item.id)">{{ $t('delete') }}</a>
            </td>
          </tr>
        </table>
      </div>
      <div class="pager-area">
        <Pagination :items="notificationForManagement" v-on:changePage="changePage" :initialPage="1"/>
      </div>
    </div>
    <Spinner :isLoading="isLoading"/>
    <b-modal id="modal-notice-manage" class="modal-content center" centered :hide-header="true" :hide-footer="true" style="width:60%; top: 50%">
      <div class="modal-inner">
        <p class="modal-ttl">{{ $t('do_you_want_to_delete_the_notification') }}</p>
        <div class="modal-btn-area clearfix">
          <div class="btn-base pos-left"><a href="javascript:;" @click="onDelete()"><p>{{ $t('ok') }}</p></a></div>
          <div class="btn-cancel pos-right"><a href="javascript:;" @click="$bvModal.hide('modal-notice-manage')" class="modal-close"><p>{{ $t('cancel') }}</p></a></div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { BModal, VBModal, BButton} from 'bootstrap-vue'
import Pagination from '@/js/components/Common/Pagination'
import Spinner from '@/js/components/Spinner'

export default {
  directives: { BModal, VBModal, BButton },
  components: {
    Pagination,
    BModal,
    VBModal,
    BButton,
    Spinner
  },
  async created() {
    this.screenTracking(this.$t('notification_management'))
    this.isLoading = true
    await this.$store.dispatch('notification/getListNotificationForManagement')
      .catch(err => {
          err.response.status == 401 ? this.$router.push('/404') : null
          return
        })
    this.isLoading = false
  },
  data() {
    return {
        pageOfItems: [],
        patients: [],
        isLoading: false,
        selectedId: null,
    }
  },
  computed: {
      ...mapState({
        notificationForManagement: state => state.notification.notificationForManagement
    }),
  },
  watch: {
  },
  methods: {
    changePage(pageOfItems) {
      this.pageOfItems = pageOfItems
    },
    clickEdit (item) {
      this.$router.push('/notifications/management/edit/'+item.id)
    },
    clickDelete (id) {
      this.selectedId = id
      this.$bvModal.show('modal-notice-manage')
    },
    async onDelete() {
      this.isLoading = true
      await this.$store.dispatch('notification/deleteDetailNotificationMangement', this.selectedId)
        .catch(err => {
          err.response.status == 401 ? this.$router.push('/404') : null
          return
        })
      this.$bvModal.hide('modal-notice-manage')
      await this.$store.dispatch('notification/getListNotificationForManagement')
        .catch(err => {
          err.response.status == 401 ? this.$router.push('/404') : null
          return
        })
      this.isLoading = false
    }
  }
};
</script>
<style scoped>
.patients-list-table th {
  vertical-align: middle;
}
.patients-list-table th:first-child {
  width: 700px;
}
.patients-list-table th:nth-child(2) {
  width: 120px;
}
.patients-list-table th:nth-child(3) {
  width: 300px;
}
.patients-list-table th:nth-child(4) {
  width: 200px;
}
.patients-list-table th:nth-child(5) {
  width: 250px;
}
.delete-btn {
  color: white;
  background-color: red;
  border-radius: 20px;
  padding: 8px 20px;
  display: inline-block;
  margin: 0px 5px;
}
.display-btn {
  border: 1px solid #ff8ea1;
  border-radius: 20px;
  padding: 8px 20px;
  display: inline-block;
  margin: 5px;
}
</style>
